import { useMutation } from '@tanstack/react-query'
import { Button, Flex, Text } from '@radix-ui/themes'
import { useTRPC } from '~/utils/trpc'
import { useInvalidateMaterialReturns } from '../useInvalidateMaterialReturns'

interface MarkReturnReceivedButtonProps {
  materialReturnId: string
}

export const MarkReturnReceivedButton = ({ materialReturnId }: MarkReturnReceivedButtonProps) => {
  const trpc = useTRPC()
  const invalidateMaterialReturns = useInvalidateMaterialReturns()

  const markReceivedMutation = useMutation(
    trpc.ops.materialReturns.markReceived.mutationOptions({
      onSuccess: (updated) => invalidateMaterialReturns(updated.installations.map((link) => link.installation_id))
    })
  )

  return (
    <Flex direction="column" gap="1" align="start">
      <Button
        size="1"
        variant="soft"
        className="whitespace-nowrap"
        loading={markReceivedMutation.isPending}
        onClick={() => markReceivedMutation.mutate({ id: materialReturnId })}
      >
        Mark as received
      </Button>
      {markReceivedMutation.error ? (
        <Text size="1" color="red">
          {markReceivedMutation.error.message}
        </Text>
      ) : null}
    </Flex>
  )
}
